var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMypageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7251 23.9625C22.5938 23.9438 22.4251 23.9438 22.2751 23.9625C18.9751 23.85 16.3501 21.15 16.3501 17.8313C16.3501 14.4375 19.0876 11.6813 22.5001 11.6813C25.8938 11.6813 28.6501 14.4375 28.6501 17.8313C28.6313 21.15 26.0251 23.85 22.7251 23.9625Z",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1373 36.3375C31.7998 39.3937 27.3748 41.25 22.4998 41.25C17.6248 41.25 13.1998 39.3937 9.8623 36.3375C10.0498 34.575 11.1748 32.85 13.1811 31.5C18.3186 28.0875 26.7186 28.0875 31.8186 31.5C33.8248 32.85 34.9498 34.575 35.1373 36.3375Z",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 41.25C32.8553 41.25 41.25 32.8553 41.25 22.5C41.25 12.1447 32.8553 3.75 22.5 3.75C12.1447 3.75 3.75 12.1447 3.75 22.5C3.75 32.8553 12.1447 41.25 22.5 41.25Z",
    stroke: "#171717",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypageIcon);
export default __webpack_public_path__ + "static/media/MypageIcon.e5195d5788b0ac7c46df1e7ab727ba06.svg";
export { ForwardRef as ReactComponent };